import { createSelector } from '@ngrx/store';

const remindersFeature = state => state.reminders;

export const getCurrentReminders = createSelector(remindersFeature, state => state.currentReminders);

export const getCurrentActiveReminders = createSelector(remindersFeature, state => state.activeReminders);
